import ApiService from '../../../../shared/services/ApiService';

export default {
    getMembersWithLocationTracking(){
        return ApiService.get('location-members');
    },

    getMembersWithSettings() {
        return ApiService.get('members-with-settings');
    },

    updateMemberLocationTracking(data){
        return ApiService.post('user-location-tracking', data);
    },
    updateCompanySettings(data){
        return ApiService.post('company-settings', data);
    }
}